enum FileExtension {
  PDF = "pdf",
  EXCEL = "excel",
  DATATABLE_EXCEL = "datatable_excel",
  CSV = "csv",
  DWG = "dwg",
  DOC = "doc",
  DOCX = "docx",
  TXT = "txt",
  MP4 = "mp4",
  TIFF = "tiff",
  SVG = "svg",
  AVI = "avi",
  GLB = "glb",
  OBJ = "obj",
  FBX = "fbx",
  STL = "stl",
  PLY = "ply",
  LAS = "las",
}

const extensionIconKeys = {
  pdf: FileExtension.PDF,
  xls: FileExtension.EXCEL,
  xlsx: FileExtension.EXCEL,
  datatable_excel: FileExtension.DATATABLE_EXCEL,
  csv: FileExtension.CSV,
  dwg: FileExtension.DWG,
  doc: FileExtension.DOC,
  docx: FileExtension.DOCX,
  txt: FileExtension.TXT,
  mp4: FileExtension.MP4,
  avi: FileExtension.AVI,
  tif: FileExtension.TIFF,
  tiff: FileExtension.TIFF,
  svg: FileExtension.SVG,
  glb: FileExtension.GLB,
  obj: FileExtension.OBJ,
  fbx: FileExtension.FBX,
  stl: FileExtension.STL,
  ply: FileExtension.PLY,
  las: FileExtension.LAS,
} as const

export const extensionIconPaths = {
  [FileExtension.PDF]: "/extensions/pdf.svg",
  [FileExtension.EXCEL]: "/extensions/excel.svg",
  [FileExtension.DATATABLE_EXCEL]: "/extensions/datatable-excel.svg",
  [FileExtension.CSV]: "/extensions/csv.svg",
  [FileExtension.DOC]: "/extensions/doc.svg",
  [FileExtension.DOCX]: "/extensions/doc.svg",
  [FileExtension.DWG]: "/extensions/dwg.svg",
  [FileExtension.TXT]: "/extensions/txt.svg",
  [FileExtension.MP4]: "/extensions/mp4.svg",
  [FileExtension.AVI]: "/extensions/avi.svg",
  [FileExtension.TIFF]: "/extensions/tiff.svg",
  [FileExtension.SVG]: "/extensions/svg.svg",
  [FileExtension.GLB]: "/extensions/glb.svg",
  [FileExtension.OBJ]: "/extensions/obj.svg",
  [FileExtension.FBX]: "/extensions/fbx.svg",
  [FileExtension.STL]: "/extensions/stl.svg",
  [FileExtension.PLY]: "/extensions/ply.svg",
  [FileExtension.LAS]: "/extensions/las.svg",
} as const

const UNSUPPORTED_IMAGE_PREVIEW_EXTENSIONS = ["svg", "tif", "tiff"] as const

export const useFileExtensions = () => {
  const getExtensionIconKey = (file: Pick<FileData, "extension" | "description" | "_id">): FileExtension | undefined => {
    const fileExtension = file.extension

    return extensionIconKeys[fileExtension as keyof typeof extensionIconKeys] ?? undefined
  }

  const getFileIconSrc = (file: Pick<FileData, "extension" | "description" | "_id">) => {
    const key = getExtensionIconKey(file)
    return key ? extensionIconPaths[key] : undefined
  }

  const canPreviewAsImage = (file: Pick<FileData, "type" | "extension">) =>
    file.type === "IMAGE" &&
    !UNSUPPORTED_IMAGE_PREVIEW_EXTENSIONS.includes(file.extension as (typeof UNSUPPORTED_IMAGE_PREVIEW_EXTENSIONS)[number])

  return { getFileIconSrc, canPreviewAsImage }
}
